/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Detail_AttributedInputs */



/**
* | output |
* | --- |
* | "Attributed customers" |
*
* @param {Partner_Admin_Detail_AttributedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_detail_attributed = /** @type {((inputs?: Partner_Admin_Detail_AttributedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Detail_AttributedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zugeordnete Kunden")
	return /** @type {LocalizedString} */ ("Attributed customers")
});